<template>
  <div>
    <!-- 头部部分 -->
    <div class="head">
      <!-- 展示的搜索条件 -->
      <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
        <el-form-item  prop="userId" v-if="adminShow">
          <el-cascader
            placeholder="代理商"
            ref="myCascader"
            :options="agentTree"
            :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false }"
            :show-all-levels="false"
            clearable
            v-model="queryParams.userId"
            @change="search"
            filterable
          ></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="dateRange"
            style="width: 240px"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
          <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 内容部分 -->
    <div class="table">
      <el-table :data="tableData" border :header-cell-style ="{background: '#EEF1F6',color: '#606266'}"  @sort-change="tableSortChange">
        <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
        <el-table-column prop="username" label="昵称" align="center" width="180px" v-if="adminShow"></el-table-column>
        <el-table-column prop="company" label="代理商" align="center"></el-table-column>
        <el-table-column prop="totalInMoney" label="总收入" align="center" sortable="custom"></el-table-column>
        <el-table-column prop="totalOutMoney" label="总支出" align="center" sortable="custom"></el-table-column>
        <el-table-column prop="availAmount" label="余额" align="center" sortable="custom"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" align="center"></el-table-column>
      </el-table>
    </div>
    <div class="block" style="margin-top: 30px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { agentTreeList } from "@/api/api.js"; //代理商
import { assetStatistical } from "@/api/api.js";//代理商余额
export default {
  data() {
    return{
      queryParams:{},
      dateRange:[],
      tableData:[],
      page: 1,
      pageSize: 20,
      total:0,
      agentTree:[],
      // 排序方式
      sortOrder: "",
      // 排序名称
      sortName: "",
    }
  },
  computed: {
    adminShow : {
      get() {
          return this.$store.getters.user.userType =='1'
        }
    },
  },
  methods: {
    // 获取列表的数据
    initData(){
      let params ={
        model:{
          ...this.addDateRange(this.queryParams, this.dateRange),
          order: this.sortOrder,
          sort: this.sortName,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      assetStatistical(params).then(res=>{
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.search();
    },
    handleSizeChange(e,pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },
    //代理商列表
    handleAgentTreeList(){
      agentTreeList().then(res => {
        this.agentTree = res.data.data;
      });
    },
    // 排序
    tableSortChange(val){
      this.sortOrder = val.order === "descending" ? "desc" : "asc";
      if(val.prop == 'totalInMoney'){
        this.sortName = 'totalInMoney'
      }else if(val.prop == 'totalOutMoney'){
        this.sortName = 'totalOutMoney'
      }else if(val.prop == 'availAmount'){
        this.sortName = 'availAmount'
      }
      this.initData()
    }
  },
  created() {
    this.initData();
    if(this.adminShow){
      this.handleAgentTreeList();
    }
  },
  mounted() {

  },
};
</script>

<style scoped lang="less">
.cell button{
  width: 50px;
  font-size: 12px;
  text-align: center;
  padding: 6px;
}
.demo-table-expand{
  display: flex;
  flex-wrap:wrap
}
.demo-table-expand .el-form-item {
  margin-bottom: 10px;
  width: 50%;
}
.searchOne{
  display: inline-block;
  .el-input{
    margin-right: 30px;
    width:210px;
  }
  .el-select{
    margin-right: 30px;
    width:210px;
  }
  .el-date-editor{
    width:450px ;
  }
}
.rotating {
  transform: rotate(90deg);
}
.el-button--small.icon-button-auto {
  padding: 12px 9px;
  position: relative;
  top: -1px;
}
.span-but{
  // margin-left: -30px;
  button{
    padding: 10px 20px;
    margin-top: 3px;
    margin-left: 5px;
  }
}
.array-class{
  width: 70%;
  display: flex;
  flex-wrap:wrap;
  margin-top: 5px;
  .el-input{
    margin-right: 30px;
    width:210px;
    margin-top: 15px;
  }
  .el-select{
    margin-right: 30px;
    width:210px;
    margin-top: 15px;
  }
  .el-date-editor{
    width:450px ;
    margin-top: 15px;
    margin-right: 30px;
  }
}
.result-c{
  color: #15C392;
  cursor: pointer;
}
.result-s{
  color: #FF0000;
  cursor: pointer;
  margin-left:10px
}
.iclass-text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 170px;
}
</style>


